import React, { ReactNode } from 'react';
import { TableTitleSortIcon } from './TableTitleSortIcon';
import { ActionsFeature, TblCol, TblSort, TblSortDir } from './table.types';
import Link from '../components/Link';

export type TblTitleParams = {
    actions?: ActionsFeature[];
    cols?: TblCol[];
    sort?: TblSort;
    onSort?: (col: string, dir?: TblSortDir) => void;
    children?: ReactNode;
};

const TableTitles = ({ actions, cols, sort, onSort, children }: TblTitleParams): JSX.Element => {
    function handleOnSort(col: string): void {
        if (!!onSort) {
            // toggle existing column
            let dir: TblSortDir = 'ASC'; // default
            if (!!sort && sort.col == col) {
                dir = sort.dir != 'ASC' ? 'ASC' : 'DSC';
            }
            onSort(col, dir);
        }
    }

    // content override
    if (!cols) {
        return <tr className="column-titles">{children}</tr>;
    }

    return (
        <tr className="column-titles">
            {actions?.map((_action, idx) => <td key={idx} />)}
            {cols.map((col, idx) =>
                col.hasSort ? (
                    <td key={col.key}>
                        <Link onClick={() => handleOnSort(col.key)}>
                            {col.title}
                            <TableTitleSortIcon
                                col={col.key}
                                sort={sort}
                            />
                        </Link>
                    </td>
                ) : (
                    <td key={idx}>{col.title}</td>
                ),
            )}
        </tr>
    );
};

export default TableTitles;
